// @flow
import './index.less';

import { MailFilled } from '@ant-design/icons';

import classNames from 'classnames';
import React from 'react';

import SignUpForm from '_components/SignUpForm';
import { useAuthState } from '_contexts/auth';

type Props = {
  active?: boolean,
};

const AccountConnector = ({ active = false }: Props): React$Node => {
  const { currentUser } = useAuthState();

  if (currentUser) {
    return (
      <div className="account-connector-connected">
        <MailFilled className="icon" />
        <span>{currentUser.email}</span>
      </div>
    );
  }

  return (
    <div className={classNames('account-connector', { 'account-connector-active': active })}>
      <SignUpForm disabled={!active} />
    </div>
  );
};

export default AccountConnector;
